<template>
  <div @click="onClick">
    <router-view v-slot="{ Component }">
      <keep-alive include="Index">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>
<script>
export default {
  setup() {
    let added = false;
    let count = 0;
    let timer = 0;
    const onClick = () => {
      if (added) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        count = 0;
      }, 1000);

      count++;
      if (count > 15) {
        // eslint-disable-next-line no-undef
        eruda && eruda.init();
        added = true;
      }
    };

    return {
      onClick,
    };
  },
};
</script>
<style lang="less"></style>
